// extracted by mini-css-extract-plugin
module.exports = {"item":"table-item_item__ArwsT","itemImg":"table-item_itemImg___3fMA","head":"table-item_head__d_GU1","subText":"table-item_subText__zNwuI"};